export default "__VITE_ASSET__28b4f61b__"